import { render } from "./allEtatEmp.vue?vue&type=template&id=8700af64"
import script from "./allEtatEmp.vue?vue&type=script&lang=ts"
export * from "./allEtatEmp.vue?vue&type=script&lang=ts"
script.render = render

export default script